class ExtranetLoginForm extends BaseForm {
	constructor(options) {
		super(options);

		//set default variables
		this.fields = [
			{name: 'email', type: 'email'},
			{name: 'password'},
		];
	}
}